<template>
    <div>

        <running-auctions-banner
            v-if="runningAuctions.length > 0"
            :auctions="runningAuctions"
        />

        <page-headline>{{$t('pages.campaigns.index.campaigns')}}</page-headline>
        <div class="flex justify-between mb-2 bg-gray-200 p-3">
            <div class="flex justify-end items-center">
                <search-filter v-model="form.template" class="w-full max-w-md mr-4" @reset="reset">
                    <label class="mt-2 block py-1 pl-3 bg-ezdBlue text-white">{{$t('pages.insights.auctions.type')}}</label>
                    <select v-model="form.template" class="w-full form-select">
                        <option value="-1">{{$t('all.auction_types.all')}}</option>
                        <option value="2">{{$t('all.auction_types.secretsale')}}</option>
                        <option value="3">{{$t('all.auction_types.secretsale')}} (Rerun)</option>
                        <option value="4">{{$t('all.auction_types.livestyle')}}</option>
                        <option value="5">{{$t('all.auction_types.livestyle')}} (Rerun)</option>
                    </select>
                    <label class="mt-2 block py-1 pl-3 bg-ezdBlue text-white">{{$t('all.start_date_from_to')}}</label>
                    <div class="border-2 border-t-0 py-2">
                        <input class="text-gray-700 text-md" type="date" name="from" value="2020-08-25" v-model="form.dateStart"/> - <input class="text-gray-700 text-md" type="date" name="to" v-model="form.dateEnd"/>
                    </div>
                </search-filter>
            </div>
        </div>
        <div class="bg-white shadow overflow-x-auto mt-6">
            <table class="w-full whitespace-nowrap bg-ezdBlue">
                <tr class="table-headline text-left">
                    <th class="px-4 py-2 font-normal">{{$t('pages.campaigns.index.campaign_columns.name')}}</th>
                    <th class="px-4 py-2 font-normal">{{$t('pages.campaigns.index.campaign_columns.start')}}</th>
                    <th class="px-4 py-2 font-normal">{{$t('pages.campaigns.index.campaign_columns.end')}}</th>
                    <th class="px-4 py-2 font-normal">{{$t('pages.campaigns.index.campaign_columns.auctions')}}</th>
                    <th class="px-4 py-2 font-normal"></th>
                </tr>
                <tr v-for="campaign in campaigns.data" :key="campaign.id" class="hover:bg-gray-300 even:bg-gray-200 odd:bg-white text-sm cursor-pointer" :class="{'border-l-4 even:border-gray-200 odd:border-white': campaign.running_auctions_count === 0, 'border-l-4 border-green-600': campaign.running_auctions_count > 0}">
                    <td @click="goto(campaign.id)" class="border-t"><a class="px-4 py-3 flex items-center">{{ campaign.name }}</a></td>
                    <td @click="goto(campaign.id)" class="border-t"><a class="px-4 py-3 flex items-center">{{ campaign.date_start | formatTime }}</a></td>
                    <td @click="goto(campaign.id)" class="border-t"><a class="px-4 py-3 flex items-center">{{ campaign.date_end | formatTime }}</a></td>
                    <td @click="goto(campaign.id)" class="border-t"><a class="px-4 py-3 flex items-center">{{ campaign.auctions_count }}</a></td>
                    <td class="border-t">
                        <span class="px-4 py-3 flex items-center">
                            <a :href="route('campaigns.control', {campaign: campaign.id})" target="_blank">
                                <icon
                                    class="h-5 w-5"
                                    name="link">
                                </icon>
                            </a>
                        </span>
                    </td>
                </tr>
                <tr v-if="campaigns.data.length === 0">
                    <td class="border-t px-6 py-4 text-center bg-white" colspan="7">{{$t('pages.campaigns.index.no_campaigns')}}</td>
                </tr>
            </table>
        </div>
        <div class="mb-6">
            <pagination :collection="campaigns" :url="$page.props.paginate.currentUrl" :params="this.form" />
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import Pagination from '@/Shared/Pagination';
import Icon from '@/Shared/Icon';
import PageHeadline from "@/Shared/PageHeadline";
import pickBy from 'lodash/pickBy';
import throttle from 'lodash/throttle';
import SearchFilter from "@/Shared/SearchFilter";
import { Link } from '@inertiajs/vue2';
import RunningAuctionsBanner from "./Components/RunningAuctionsBanner.vue";
export default {
    metaInfo() {
        return {
            title: this.$t('pages.campaigns.index.campaigns')
        }
    },
    layout: Layout,
    components: {
        RunningAuctionsBanner,
        Pagination,
        Icon,
        PageHeadline,
        SearchFilter,
        Link
    },
    props: {
        campaigns: Object,
        states: Object,
        runningAuctions: Array
    },
    data() {
        return {
            form: {
                template: '-1'
            }
        }
    },
    watch: {
        form: {
            handler: throttle(function() {
                let query = pickBy(this.form);
                this.$inertia.get(this.route('campaigns.list', Object.keys(query).length ? query : {}), {}, { preserveState: true })
            }, 150),
            deep: true
        }
    },
    methods: {
        reset() {
            this.form = {}
        },
        printCampaign(campaignId) {
            window.open(
                route('campaigns.print', { campaign: campaignId }),
                "_blank"
            );
        },
        goto(campaignId) {
            this.$inertia.visit(route('campaigns.control', {campaign: campaignId}));
        }
    }
}
</script>
